import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { nivedanStatus } from 'src/app/core/models/status.enum';
// import { BlockList } from 'net';
import { CommentDialogComponent } from 'src/app/shared/components/fly-out-dashboard-details/comment-dialog/comment-dialog.component';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-show',
  templateUrl: './nibedon-dtls-dialog.component.html',
  styleUrls: ['./nibedon-dtls-dialog.component.scss'],
})
export class NibedonDtlsComponent implements OnInit {
  title!: string;
  message!: string;
  isMobile: boolean = false;
  isPrint: boolean = false
  commentArr: any [] = []
  constructor(
    public sheetRef: MatBottomSheetRef<NibedonDtlsComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheet: MatBottomSheet,
    private dialog: MatDialog,
    private toaster: ToastrService
  ) { }

  closeDialog() {
    this.sheetRef.dismiss(false);
  }

  ngOnInit(): void {
    this.isMobile = window.matchMedia('(max-width: 600px)').matches
    console.log(this.data);

    this.commentArr = this.data.statusCommentTrail.filter((v: any) => v['comment'])

  }

  colorForStatus(status: string, type: 'font' | 'bg'): string {
    if (status === nivedanStatus.ASSIGNED && type?.toLowerCase() === 'font') {
      return 'status-solverPending-font';
    } else if (status === nivedanStatus.ASSIGNED && type?.toLowerCase() === 'bg') {
      return 'status-solverPending-bg';
    } else if (status === nivedanStatus.IN_REVIEW && type?.toLowerCase() === 'font') {
      return 'status-solved-font';
    } else if (status === nivedanStatus.IN_REVIEW && type?.toLowerCase() === 'bg') {
      return 'status-solved-bg';
    } else if (status === nivedanStatus.NEW && type?.toLowerCase() === 'font') {
      return 'status-open-font';
    } else if (status === nivedanStatus.NEW && type?.toLowerCase() === 'bg') {
      return 'status-open-bg';
    } else if (status === nivedanStatus.RESOLVED && type?.toLowerCase() === 'font') {
      return 'status-resolved-font';
    } else if (status === nivedanStatus.RESOLVED && type?.toLowerCase() === 'bg') {
      return 'status-resolved-bg';
    } else if (status === nivedanStatus.RESPONSE_PENDING && type?.toLowerCase() === 'font') {
      return 'status-response-pending-font'
    } else if (status === nivedanStatus.RESPONSE_PENDING && type?.toLowerCase() === 'bg') {
      return 'status-response-pending-bg'
    }
    else {
      return "";
    }
  }

  commentDialog() {
          this.sheetRef.dismiss(true);

    // const bottomsheetRef = this.bottomSheet.open(CommentDialogComponent, {
    //   data: this.data
    // })
    // bottomsheetRef.afterDismissed().subscribe({
    //   next: (res) => {
    //     if (res) {
    //       //  window.location.reload()
    //       this.sheetRef.dismiss(true);
    //     }
    //   },
    //   error: (err) => {
    //     this.toaster.error(err)
    //   }
    // })
  }

  showComment() {
    this.isPrint = true

  }

  closeComment() {
    this.isPrint = false
  }
}
